import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useAdminAuth } from './AdminAuthContext'

export function RequireAdminAuth() {
  const { isReady, isAdmin } = useAdminAuth()
  const location = useLocation()

  if (!isReady) {
    return (
      <div className="flex min-h-dvh items-center justify-center bg-zinc-50 text-zinc-600 dark:bg-zinc-950 dark:text-zinc-400">
        Φόρτωση…
      </div>
    )
  }

  if (!isAdmin) {
    return (
      <Navigate to="/admin/login" replace state={{ from: location.pathname }} />
    )
  }

  return <Outlet />
}
